import { render, staticRenderFns } from "./sluser-add-or-update.vue?vue&type=template&id=d94a99a0&"
import script from "./sluser-add-or-update.vue?vue&type=script&lang=js&"
export * from "./sluser-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports